import {
  DarkModeOutlined,
  Language,
  LightModeOutlined,
} from "@mui/icons-material";
import {
  AppBar,
  Avatar,
  Button,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import Popover from "@mui/material/Popover";
import { useGetIdentity, useTranslation } from "@refinedev/core";
import UserPopoverList from "components/UserPopoverList";
import React, { useContext } from "react";
import { useTranslation as usei18nextTranslation } from "react-i18next";
import { ColorModeContext } from "../../contexts/color-mode";

type IUser = {
  id: number;
  name: string;
  avatar: string;
};

export const Header: React.FC = () => {
  const { mode, setMode } = useContext(ColorModeContext);

  const { data: user } = useGetIdentity<IUser>();
  const showUserInfo = user && (user.name || user.avatar);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const { i18n } = usei18nextTranslation();
  const { getLocale, changeLocale } = useTranslation();
  const currentLocale = getLocale();

  console.log({ currentLocale });

  const handleLanguageChange = (lang: string) => {
    console.log({ lang });
    changeLocale(lang);
  };

  const [anchorElMenu, setAnchorElMenu] = React.useState<null | HTMLElement>(
    null
  );
  const [openMenu, setOpenMenu] = React.useState(false);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElMenu(event.currentTarget);
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setAnchorElMenu(null);
    setOpenMenu(false);
  };

  const menuItems = [...(i18n.languages || [])].sort().map((lang: string) => (
    <MenuItem key={lang} onClick={() => handleLanguageChange(lang)}>
      <Avatar
        src={`/images/flags/${lang}.svg`}
        alt={lang}
        sx={{ width: 24, height: 24, marginRight: 1 }}
      />
      {lang === "en" ? "English" : "Frensh"}
    </MenuItem>
  ));

  return (
    <AppBar color="default" position="sticky" elevation={1}>
      <Toolbar>
        <Stack
          direction="row"
          width="100%"
          justifyContent="flex-end"
          alignItems="center"
          position="relative"
        >
          <Toolbar sx={{ justifyContent: "flex-end" }}>
            <IconButton color="inherit" onClick={handleMenuOpen}>
              <Language />
            </IconButton>
            <Button color="inherit" onClick={handleMenuOpen}>
              {currentLocale === "en" ? "English" : "Frensh"}
            </Button>
            <Menu
              id="language-menu"
              anchorEl={anchorElMenu}
              open={openMenu}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                top: 20,
              }}
            >
              {menuItems}
            </Menu>
          </Toolbar>
          <IconButton
            onClick={() => {
              setMode();
            }}
          >
            {mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
          </IconButton>
          {showUserInfo && user?.name ? (
            <Stack direction="row" gap="16px" alignItems="center">
              <CardHeader
                avatar={
                  <IconButton
                    size="small"
                    aria-describedby={id}
                    onClick={handleClick}
                  >
                    <Avatar sx={{ bgcolor: "#06d6a0" }} aria-label="recipe">
                      <Typography textTransform="uppercase">
                        {user?.name[0]}
                      </Typography>
                    </Avatar>
                  </IconButton>
                }
                title={user?.name}
                subheader="Online"
              />
              {user.avatar && <Avatar src={user?.avatar} alt={user?.name} />}
            </Stack>
          ) : null}

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            PaperProps={{
              sx: {
                top: 100,
                width: 285,
                left: 100,
              },
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ px: 2, mt: 1, pt: 1 }} fontWeight="bold">
              Welcome!
            </Typography>
            <UserPopoverList />
          </Popover>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
